module.exports = __webpack_public_path__ + "static/media/Ebips-image.d866dfd0.png";